import axios from "axios";

export const straconClient = axios.create({
  baseURL: `${process.env.REACT_APP_ADMIN_URL}/api/`,
  headers: {
    "Content-Type": "application/json",
    Authorization: process.env.REACT_APP_TOKEN_API_STRACON,
  },
});

//"Accept, Content-Type, Content-Length, Accept-Encoding, Grpc-Metadata-Authorization"

/*
'Content-Length':'',
    'Accept-Encoding':'',
    'Grpc-Metadata-Authorization':'',
*/
